module.exports = __webpack_public_path__ + "img/buttonArrow.82fb5734.svg";